export const EMLogo = () => {
  return (
    <>
      <svg
        className="hidden dark:block h-5 w-5"
        id="Layer_1"
        data-name="Layer 1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 162 292"
      >
        <polygon
          className="cls-1"
          fill="#FFF"
          points="162 32 162 0 0 0 0 292 33 292 33 162 65 162 65 292 97 292 97 162 130 162 130 292 162 292 162 129 33 129 33 97 162 97 162 64 33 64 33 32 162 32 162 32"
        />
      </svg>
      <svg
        className="block dark:hidden h-5 w-5"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 162.4 292.2"
        xmlSpace="preserve"
      >
        <g>
          <polygon
            points="162.4,32.5 162.4,0 0,0 0,292.2 32.5,292.2 32.5,162.4 64.9,162.4 64.9,292.2 97.4,292.2 97.4,162.4 129.9,162.4 
          129.9,292.2 162.4,292.2 162.4,129.9 32.5,129.9 32.5,97.4 162.4,97.4 162.4,64.9 32.5,64.9 32.5,32.5 	"
          />
        </g>
      </svg>
    </>
  );
};
